import supabase from "../supabase";

export async function authenticatedFetch(
  url: string,
  options: RequestInit = {}
): Promise<Response> {
  const {
    data: { session },
  } = await supabase.auth.getSession();
  const headers = new Headers(options.headers || {});

  if (session?.access_token) {
    headers.set("Authorization", `Bearer ${session.access_token}`);
  }

  let response = await fetch(url, { ...options, headers });

  // If 401, try refreshing the session and retry once
  if (response.status === 401 && session) {
    const { data: refreshed } = await supabase.auth.refreshSession();
    if (refreshed.session?.access_token) {
      headers.set(
        "Authorization",
        `Bearer ${refreshed.session.access_token}`
      );
      response = await fetch(url, { ...options, headers });
    }
  }

  // If still 401 after refresh, redirect to login
  if (response.status === 401) {
    window.location.href = "/login";
  }

  return response;
}
